jQuery(document).on("swup:pageView", function () {
  $ = jQuery;

  // ETF Template Page
  if ($("main.etf").length) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    /*****************************************************************
    // Scroll Spy for Menu Items
    *****************************************************************/
    $(window).scroll(function () {
      var Scroll = $(window).scrollTop();

      $('[id^="scroll-"]').each(function (i, e) {
        var currentSection = $(e).offset().top;
        if (Scroll >= currentSection) {
          $(".etf-submenu li").removeClass("current-menu-item");
          $(".etf-submenu li").eq(i).addClass("current-menu-item");
        }
      });
    });

    /*****************************************************************
    // Gradient Background Movement
    *****************************************************************/
    $(document).mousemove(function (event) {
      windowWidth = $(window).width();
      windowHeight = $(window).height();

      mouseXpercentage = Math.round((event.pageX / windowWidth) * 100);
      mouseYpercentage = Math.round((event.pageY / windowHeight) * 100);

      $(".radial-gradient").css("background", "radial-gradient(at " + mouseXpercentage + "% " + mouseYpercentage + "%, #5679BC 20%, #be7575 100%)");
    });

    /*****************************************************************
    // Mobile Slider for ETF Reasons Section
    *****************************************************************/
    var $mobileEtfSlider = $(".etf-reasons .owl-carousel");
    var quote_count = parseInt($mobileEtfSlider.find(".slide").length);
    $mobileEtfSlider.owlCarousel({
      loop: false,
      rewind: true,
      nav: true,
      navContainer: ".num-nav",
      navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="25.699" height="21.698" viewBox="0 0 25.699 21.698"><path id="Arrow" d="M26.284,14.506,24.5,12.719,17.41,19.793V.156H14.874V19.793L7.8,12.706,6,14.506,16.142,24.648Z" transform="translate(0.344 26.991) rotate(-90)" fill="none" stroke="#FFFFFF" stroke-width="1"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="25.699" height="21.698" viewBox="0 0 25.699 21.698"><path id="Arrow" d="M26.284,14.506,24.5,12.719,17.41,19.793V.156H14.874V19.793L7.8,12.706,6,14.506,16.142,24.648Z" transform="translate(0.344 26.991) rotate(-90)" fill="none" stroke="#FFFFFF" stroke-width="1"/></svg>'],
      items: 1,
      singleItem: true,
      margin: 0,
      dots: false,
      autoHeight: false,
      smartSpeed: 600,
      checkVisibility: true,
      onInitialize: function (e) {
        // Check if only one slide in carousel
        if (quote_count == 1) {
          // console.log("only one");
          this.options.loop = false;
          this.options.nav = false;
          this.options.mouseDrag = false;
        } else {
          this.options.loop = false; // Changed for rewind fix can change back if needed
          this.options.nav = true;
          this.options.mouseDrag = true;
        }
      },
    });

    $mobileEtfSlider.on("changed.owl.carousel", function (e) {
      var numsSingle = $(".reason-number .nums .num-single");
      var numsTotal = $(".reason-number .nums .num-total");

      numsSingle.addClass("added");

      setTimeout(function () {
        numsSingle.text(e.item.index + 1);
        numsSingle.removeClass("added");
      }, 300);

      numsTotal.text(e.item.count);
    });

    $(window).on("resize", function () {
      $(".etf-reasons .owl-carousel .owl-stage-outer").width(innerWidth);
    });

    /*****************************************************************
     * ETF Holdings Table Hide / Reveal
     *****************************************************************/
    $(".holdings-table .row").each(function (index, el) {
      if (index < 11) {
        $(el).addClass("show");
      }
    });

    $(".holdings-cta").click(function () {
      $(this).remove();
      $(".holdings-table .row").each(function (index, el) {
        $(el).addClass("show");
      });
    });

    /*****************************************************************
     * Cumulative Table Tabs
     *****************************************************************/
    $(".btn-controls .btn-ctrl").each(function (index, el) {
      $(el).click(function (e) {
        $(".btn-controls .btn-ctrl").removeClass("active");
        $(el).addClass("active");

        $(".cumulative-averages-table .flex-thead, .cumulative-averages-table .flex-tbody").removeClass("show");

        $(".cumulative-averages-table .flex-thead").eq(index).addClass("show");
        $(".cumulative-averages-table .flex-tbody").eq(index).addClass("show");
      });
    });
  }
});
